import { format } from 'date-fns'
import { useHistory } from 'react-router-dom'
import { Tag } from '@pepper/ui'

import s from './Row.module.css'

type Props = {
  projectId: string
  draft: ProjectTemplateList
  refetchDrafts: () => void
}

const Row = ({ draft, projectId }: Props) => {
  const history = useHistory()

  return (
    <div
      role="none"
      onClick={() =>
        history.push({
          pathname: '/create-project-flow',
          search: `?draft_id=${draft.id}&projectId=${projectId}`,
        })
      }
      className={s.row}
    >
      <div className={s.left}>
        <div className={s.title}>{draft.project_title}</div>
      </div>
      <div className={s.right}>
        {draft?.vertical?.name && (
          <div className={s.vertical}>
            <Tag className={s.tag}>{draft.vertical.name}</Tag>
          </div>
        )}
        <div
          title={format(new Date(draft.created_at), 'dd MMM yyyy HH:mm a')}
          className={s.dateWrapper}
        >
          {format(new Date(draft.created_at), 'dd MMM')}
        </div>
      </div>
    </div>
  )
}

export default Row
